import { render, staticRenderFns } from "./ModalTemplate.vue?vue&type=template&id=720e442d&scoped=true"
import script from "./ModalTemplate.vue?vue&type=script&lang=js"
export * from "./ModalTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720e442d",
  null
  
)

export default component.exports